import Api from '../../base/api.typings';
import axiosConfiguration from '@/base/axios-configuration';

class DocumentoService {
    async listarDocumentos(query: Api.App.Server.Documentos.ListarDocumentos.Query): Promise<Api.App.Server.Documentos.ListarDocumentos.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Documentos/ListarDocumentos', { params: query }).then(e => e.data);
    }

    async obterArquivo(query: { id: string , empresaId: any}): Promise<{ arquivo: string, tipoArquivo: Api.App.Server.Documentos.ObterCaminhoArquivo.TipoArquivo, extensao: string }> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Documentos/ObterArquivo', { params: query }).then(e => e.data);
    }
}

export default new DocumentoService();